import api from './axios';

export const getAuditLogs      = (params)             => api.get('/audit-logs', { params });
export const getAccessLogs     = (params)             => api.get('/access-logs', { params });
export const getModelHistory   = (modelType, modelId) => api.get(`/audit-logs/${modelType}/${modelId}`);
